import script from "./BarcodeReaderMixin.vue?vue&type=script&lang=ts"
export * from "./BarcodeReaderMixin.vue?vue&type=script&lang=ts"

export default script